import { render, staticRenderFns } from "./singleImage.vue?vue&type=template&id=437f94bc"
import script from "./singleImage.vue?vue&type=script&lang=js"
export * from "./singleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports